import { createFileRoute } from "@tanstack/react-router";
import { AulaExperimentalPage } from "@/components/aulas/AulaExperimentalPage";
import { AREAS } from "@/lib/aulas-experimentais/config";
import { buildFAQJsonLd } from "@/lib/aulas-experimentais/jsonld";

const area = AREAS.combo;

const URL = "https://fisioemortopedia.com.br/aulas-experimentais-pos-todas";

export const Route = createFileRoute("/aulas-experimentais-pos-todas")({
  head: () => ({
    meta: [
      { title: area.metaTitle },
      { name: "description", content: area.metaDescription },
      { property: "og:title", content: area.metaTitle },
      { property: "og:description", content: area.metaDescription },
      { property: "og:url", content: URL },
      { property: "og:type", content: "website" },
      { name: "twitter:title", content: area.metaTitle },
      { name: "twitter:description", content: area.metaDescription },
    ],
    links: [{ rel: "canonical", href: URL }],
    scripts: [{ type: "application/ld+json", children: JSON.stringify(buildFAQJsonLd(area)) }],
  }),
  component: () => <AulaExperimentalPage area={area} />,
});
